import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Material UI
import TextField from './input';
import MuiAutocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';

const Autocomplete = ({ loading, name, label, helperText, required, placeholder, TextProps, onChange, getOptionValue, ...rest }) => {
    const [open, setOpen] = useState(false)

    const handleOnChange = (e, o) => {
        const value = !Array.isArray(o)
            ? getOptionValue(o)
            : o.map(getOptionValue)

        onChange(e, o, name, value)
    }

    return (
        <MuiAutocomplete
            size='small'
            loading={loading}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            loadingText='Cargando...'
            noOptionsText='Sin resultados'
            onChange={handleOnChange}
            filterSelectedOptions
            renderInput={params =>
                <TextField
                    {...params}
                    variant='outlined'
                    fullWidth
                    name={name}
                    label={label}
                    required={required}
                    placeholder={placeholder}
                    helperText={helperText}
                    {...TextProps}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {open && loading ? <CircularProgress color='inherit' size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        )
                    }}
                />}
            {...rest}
        />
    )
}

Autocomplete.defaultProps = {
    getOptionValue: (option) => option,
    getOptionLabel: (option) => option?.label || option || ''
}

Autocomplete.prototype = {
    getOptionValue: PropTypes.func,
    getOptionLabel: PropTypes.func
}

export default Autocomplete;